'use strict';

var average = require('./average');

module.exports = average;


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/avg.js
// module id = 1634
// module chunks = 2